import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import ResponsiveImage from "studio-edifique/components/ResponsiveImage";

function ProjectPreviewCard({
  image,
  title,
  description,
  categories,
  actionLabel,
  onAction,
  path,
}) {
  return (
    <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <MKBox position="relative" borderRadius="lg" mx={2} mt={-3}>
        <ResponsiveImage
          src={image}
          alt={title}
          style={{ aspectRatio: "4 / 3", objectFit: "cover" }}
        />
      </MKBox>
      <MKBox p={3} mt={-2} display="flex" flexDirection="column" flexGrow={1}>
        {categories.length > 0 && (
          <MKTypography display="block" variant="button" color="text" fontWeight="regular" mb={1}>
            {categories.join(" • ")}
          </MKTypography>
        )}
        <MKTypography variant="h5" fontWeight="bold" mb={1.25}>
          {title}
        </MKTypography>
        <MKTypography variant="body2" color="text" mb={3} sx={{ flexGrow: 1 }}>
          {description}
        </MKTypography>
        <MKButton variant="outlined" color="dark" onClick={onAction}>
          {actionLabel}
        </MKButton>
        {path && (
          <MKButton component={Link} to={path} color="info" variant="text" sx={{ mt: 1 }}>
            Conhecer projeto
          </MKButton>
        )}
      </MKBox>
    </Card>
  );
}

ProjectPreviewCard.defaultProps = {
  actionLabel: "Ver galeria",
  categories: [],
};

ProjectPreviewCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(PropTypes.string),
  actionLabel: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  path: PropTypes.string,
};

export default ProjectPreviewCard;
